(() => {
  const init = scope => {
    scope.querySelectorAll('[data-garage]').forEach(garage => {
      if (garage.dataset.ready) return;
      garage.dataset.ready = 'true';
      const selectors = [...garage.querySelectorAll('[data-select]')];
      const choose = key => {
        garage.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== key);
        selectors.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.select === key)));
      };
      selectors.forEach(button => button.addEventListener('click', () => choose(button.dataset.select)));
      garage.querySelectorAll('.kv-view-switch button').forEach(button => button.addEventListener('click', () => {
        const frame = button.closest('.kv-feature-image');
        frame.dataset.view = button.dataset.view;
        frame.querySelectorAll('button').forEach(peer => peer.setAttribute('aria-pressed', String(peer === button)));
      }));
      if (selectors.length) choose(selectors[0].dataset.select);
    });
    scope.querySelectorAll('[data-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const photos = [...product.querySelectorAll('.kp-gallery-stage [data-photo]')];
      const thumbnails = [...product.querySelectorAll('[data-thumbnail]')];
      const show = key => {
        if (!photos.some(photo => photo.dataset.photo === key)) return;
        photos.forEach(photo => photo.hidden = photo.dataset.photo !== key);
        thumbnails.forEach(link => link.setAttribute('aria-current', String(link.dataset.thumbnail === key)));
      };
      thumbnails.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        show(link.dataset.thumbnail);
      }));
      const select = product.querySelector('[data-variant]');
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        product.querySelector('[data-price]').textContent = option.dataset.price;
        const add = product.querySelector('[data-add]');
        const available = option.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? add.dataset.label : add.dataset.soldLabel;
        if (option.dataset.photo) show(option.dataset.photo);
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      };
      if (photos.length) show(photos[0].dataset.photo);
      select.addEventListener('change', update);
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
